import GameStructuredData from 'containers/GameContainer/components/GameStructuredData';
import { GameContainer, GameContainerProps } from 'containers/GameContainer';
import GameDetails from 'containers/GameContainer/components/GameDetails';
import { entryPoint } from 'react_rails/entryPoint';

export default entryPoint(function Show(props: GameContainerProps) {
  return (
    <GameContainer {...props}>
      <GameStructuredData />
      <GameDetails />
    </GameContainer>
  );
});
